import { Typography } from "@mui/material";
import { T } from "../../util/t";

export const Registered = () =>
    <Typography><T>Registered</T></Typography>;
